// ================================================================================
// script.js
// 案件用のスクリプトファイル
// ================================================================================

// DOM Read for Vanilla
// --------------------------------------------------------------- //

document.addEventListener('DOMContentLoaded', () => {

	// breakpoint
	const breakpoint = window.matchMedia( 'screen and (min-width: 961px)' )

	// scroll volume
	function getScrolled() {
		return ( window.pageYOffset !== undefined ) ? window.pageYOffset: document.documentElement.scrollTop;
	}

	// user agent
	let deviceFlg = '';
	isUserAgent();

	function isUserAgent() {
		var ua = navigator.userAgent;

		if (ua.search(/iPhone/) != -1 || ua.search(/iPad/) != -1) {
			// iphone, ipad
			deviceFlg = 'apple';
		} else {
			// Andoird, other
			deviceFlg = 'other';
		}
	}



	// dropdown for mobile
	// --------------------------------------------------------------- //

	const dropDownButton = document.getElementById('js-mobile-menu')
	const menuOpenTarget = document.querySelector('body');
	const closeButton = document.querySelectorAll('#js-site-menu-list .site-menu-item__link');

	dropDownButton.addEventListener('click', function() {
		dropDownButton.classList.toggle('is-close')
		menuOpenTarget.classList.toggle('is-menu-open')
	} );

	for ( let i = 0; i < closeButton.length; i++) {
		closeButton[i].addEventListener('click', function() {
			dropDownButton.classList.remove('is-close')
			menuOpenTarget.classList.remove('is-menu-open')
		} );
	}



	// page top
	// --------------------------------------------------------------- //

	function scrollToTop() {
		var scrolled = getScrolled();
		window.scrollTo( 0, Math.floor( scrolled / 2 ) );
		if ( scrolled > 0 ) {
			window.setTimeout( scrollToTop, 30 );
		}
	};

	const pagetopButton   = document.getElementById('js-pagetop')

	pagetopButton.onclick = function() {
		scrollToTop();
	};



	// floating
	// --------------------------------------------------------------- //

	const floating = document.getElementById('js-floating')

	if ( floating ) {
		let heightTarget = document.getElementById('entry')

		window.onscroll = function(e) {
			let endPost = (heightTarget.getBoundingClientRect().top + window.pageYOffset ) - window.innerHeight
			let offset = window.pageYOffset

			if ( offset > endPost ) {
				floating.classList.remove('is-active')
			} else {
				floating.classList.add('is-active')
			}

		}
	}




	// form status
	// --------------------------------------------------------------- //

	$('.js-form-status').click(function () {
		var $val = $(this).val();
		if ($val == 1) {
			$('.js-form-status-toggle').fadeIn('fast');
			$('.js-separation-year').addClass('js-require');
			$('.js-separation-month').addClass('js-require');
		} else {
			$('.js-form-status-toggle').hide();
			$('.js-separation-year').removeClass('js-require');
			$('.js-separation-month').removeClass('js-require');
		}
	});

	if ($('input[name=status]:checked').val() == 1) {
		$('.js-form-status-toggle').fadeIn('fast');
		$('.js-separation-year').addClass('js-require');
		$('.js-separation-month').addClass('js-require');
	} else {
		$('.js-form-status-toggle').hide();
		$('.js-separation-year').removeClass('js-require');
		$('.js-separation-month').removeClass('js-require');
	}



} );



